import { render } from "./garage-vehicle-details.vue?vue&type=template&id=25aa3d9c"
import script from "./garage-vehicle-details.vue?vue&type=script&lang=js"
export * from "./garage-vehicle-details.vue?vue&type=script&lang=js"

import "./garage-vehicle-details.vue?vue&type=style&index=0&id=25aa3d9c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__